var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v("\n  © 2011-2018 MAG.travel Проект Master-Agent. Все права защищены. +7 (495) 6-020-020, info@mag.travel\n")])}
var staticRenderFns = []

export { render, staticRenderFns }